import { tokens, text } from './input.readonly.style.js';
import { jsx } from 'react/jsx-runtime';

function OnImageReadonlyInput(props) {
  const content = (() => {
    let base = props.input.text;
    if (props.input.style.bold) {
      base = /*#__PURE__*/jsx("b", {
        children: base
      });
    }
    if (props.input.style.italic) {
      base = /*#__PURE__*/jsx("em", {
        children: base
      });
    }
    return base;
  })();
  return /*#__PURE__*/jsx("div", {
    className: text,
    "data-alignment": props.input.style.align,
    style: tokens.__override({
      x: `${props.input.placement.x * 100}%`,
      y: `${props.input.placement.y * 100}%`,
      scale: props.scale
    }),
    children: content
  });
}

export { OnImageReadonlyInput };
//# sourceMappingURL=input.readonly.js.map
